<svg
  class="graphContainer associations"
  id="graphContainer"
  data-testid="graph-container"
  width="100%"
  height="100%"
  #graphContainer
></svg>
